// @owners { team: patients-team }
import { COLORS, SIZES, SPACING } from '@alto/design-library-tokens';
import { Body, Column, MdPadding, MdSpacing, Row, SizedImage, XxsSpacing } from '@alto/design-system';
import { Pill, ProgynyEarlyOrderTag } from '@alto/features';
import { type PrescriptionStatus } from '@alto/scriptdash/alto/patient_app/types/v1/prescription_status';
import React from 'react';
import { formatDollarsWithPlaceholder } from '~shared/helpers/currency';
import { MedicationCTA } from '~web/features/homescreen/sections/MedicationCTA';

export type NeedleRowPrescription = {
  id: number;
  status: PrescriptionStatus;
  image_url: string;
  quantity: number;
  price: number | null | undefined;
  name: string;
  family_member_name: string;
  auto_refill_eligible: boolean;
  manual_coupon_eligible: boolean;
};

type Props = {
  readonly prescriptions: NeedleRowPrescription[];
};

export const NeedleRowList = ({ prescriptions }: Props) => {
  return (
    <>
      {prescriptions.map((prescription: NeedleRowPrescription) => (
        <MdPadding
          key={prescription.id}
          leftPadding={SPACING.STATIC.NONE}
          rightPadding={SPACING.STATIC.NONE}
        >
          <Row spaceBetween>
            <Row>
              <Column>
                {prescription.image_url ? (
                  <SizedImage
                    // @ts-expect-error - image url type is string and is valid source type
                    source={prescription.image_url}
                    pixelSize={SIZES.ILLUSTRATION.SM.value}
                    maxHeight={SIZES.ILLUSTRATION.SM.value}
                  />
                ) : (
                  <Pill />
                )}
              </Column>
              <MdSpacing />
              <Column>
                <Body color={COLORS.TEXT_COLORS.PRIMARY}>{prescription.name}</Body>
                <XxsSpacing />
                {prescription.quantity ? (
                  <>
                    <Body
                      textSize="mini"
                      color={COLORS.TEXT_COLORS.GREY}
                    >
                      Qty: {prescription.quantity}
                    </Body>
                    <XxsSpacing />
                  </>
                ) : null}
                {prescription.status === 'ready' ? (
                  <Body
                    textSize="mini"
                    color={COLORS.TEXT_COLORS.GREY}
                  >
                    {typeof prescription.price === 'number'
                      ? formatDollarsWithPlaceholder(prescription.price, '')
                      : 'View Price in Cart'}
                  </Body>
                ) : null}
                <ProgynyEarlyOrderTag
                  origin="MedList"
                  prescriptionId={prescription.id}
                  prescriptionName={prescription.name}
                  prescriptionStatus={prescription.status}
                />
              </Column>
            </Row>
            <Column centerVertically>
              <MedicationCTA
                fullWidthButton
                prescription={prescription}
              />
            </Column>
          </Row>
        </MdPadding>
      ))}
    </>
  );
};
